import Contact from '../screen/container/contact/contact';

export const routesContact = [
    {
      component: Contact,
      exact: true,
      path: "/contact/support",
      guard: "public",
    },
  ];